import React, { useState } from "react";
import { Button, Drawer, IconButton, MenuItem, Select, TextField } from "@mui/material";
import { IoFilter } from "react-icons/io5";
import CustomModal from "../../../components/CustomModal";
import { X } from "lucide-react";
import { useTheme } from "../../../style/theme";

export default function RelatedChecklists() {
  const [filterModal, setFilterModal] = useState(false);
  const [option, setOption] = useState("");


  const status = [
    { value: "Open", label: "Open" },
    { value: "Completed", label: "Completed" },
  ];
  const relatedForms = [
    { value: "Address Proof", label: "Address Proof" },
    { value: "Bonafide Letter", label: "Bonafide Letter" },
    { value: "Compensatory Request", label: "Compensatory Request" },
    { value: "Department", label: "Department" },
    { value: "Designation", label: "Designation" },
  ];


  const taskowner = [
    { value: "Tanya Gwilsbry", label: "Tanya Gwilsbry" },
    { value: "Saad Khan", label: "Saad Khan" },
  ];

  const {mode} = useTheme()
  return (
    <div className="w-full min-h-80 flex flex-col">
      <div className="w-full flex gap-3 justify-end items-center">
        <IconButton
          onClick={() => {
            setFilterModal(true);
          }}
          title="Filter"
        >
          <IoFilter size={16}/>
        </IconButton>
      </div>
      <div className="w-full flex flex-col justify-center items-center mt-[100px]">
      <img src="/images/noGoal.png" alt="" />
        <h1 className="mt-[20px]">No checklists to list here</h1>
      </div>
      {/* <div>
        <CustomModal
          title="Filter"
          submitLabel="Apply"
          fields={filterModalFields}
          open={filterModal}
          onClose={() => {
            setFilterModal(false);
          }}
          onSubmit={handleFilterFormSubmit}
          // isScrollable={true}
        />
      </div> */}

      <Drawer
              anchor="right"
              open={filterModal}
              onClose={() => setFilterModal(false)}
            >
              <div
                style={{
                  backgroundColor: mode === "light" ? "#fff" : "background.view",
                }}
                className="w-72 p-4"
              >
                <div className="flex justify-between items-center">
                  <h2 className="text-lg font-semibold mb-4">Filter</h2>
                  <button
                    className="border-none outline-none"
                    onClick={() => setFilterModal(false)}
                  >
                    <X size={20} />
                  </button>
                </div>
                <div>
                  <TextField
                    placeholder="Task Name"
                    size="small"
                    className="w-full"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "38px",
                      },
                    }}
                  />
                </div>
      
                <label className="block text-sm font-medium mb-2 text-[#666666] mt-2">
                  Status
                </label>
                <Select
                  value={option} // Directly bind `filter`
                  onChange={(e) => setOption(e.target.value)} // MUI ke liye `.target.value` use hota hai
                  fullWidth
                  sx={{
                    backgroundColor: mode === "light" ? "#fff" : "transparent",
                    height: "34px",
                  }}
                >
                  {status.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
      
                <label className="block text-sm font-medium mb-2 text-[#666666] mt-2">
                  Related Forms
                </label>
                <Select
                  value={option} // Directly bind `filter`
                  onChange={(e) => setOption(e.target.value)} // MUI ke liye `.target.value` use hota hai
                  fullWidth
                  sx={{
                    backgroundColor: mode === "light" ? "#fff" : "transparent",
                    height: "34px",
                  }}
                >
                  {relatedForms.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
      
                <label className="block text-sm font-medium mb-2 text-[#666666] mt-2">
                  Checklist initiator
                </label>
                <Select
                  value={option} // Directly bind `filter`
                  onChange={(e) => setOption(e.target.value)} // MUI ke liye `.target.value` use hota hai
                  fullWidth
                  sx={{
                    backgroundColor: mode === "light" ? "#fff" : "transparent",
                    height: "34px",
                  }}
                >
                  {taskowner.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
      
           
              </div>
              <div className="flex items-end h-full mb-5 justify-start px-5 space-x-2">
                <Button variant="contained" sx={{ bgColor: "#0088ff" }}>
                  Apply
                </Button>
                <Button variant="outlined" onClick={() => setOption("")}>
                  Reset
                </Button>
              </div>
            </Drawer>
    </div>
  );
}
